export default __webpack_public_path__ + "0623d7350c301fdcd76f664e9256dc3d.png";